module.exports = __webpack_public_path__ + "static/media/butterfly-soul_59145-4.2636e2d5.png";